module.exports = __webpack_public_path__ + "static/media/filter.add8aac6.png";